export const LoaderIcon = () => {
    return (
        <path
            id="Base"
            d="M19 10C19.5523 10 20.0052 10.4488 19.95 10.9984C19.7738 12.7549 19.1348 14.44 18.0902 15.8779C16.8489 17.5863 15.0986 18.858 13.0902 19.5106C11.0817 20.1631 8.91826 20.1631 6.90983 19.5106C4.9014 18.858 3.15111 17.5863 1.90983 15.8779C0.668549 14.1694 -1.84619e-07 12.1118 0 10C1.84619e-07 7.88821 0.66855 5.83062 1.90983 4.12215C3.15111 2.41367 4.9014 1.14201 6.90983 0.489434C8.6001 -0.0597676 10.4002 -0.146768 12.1252 0.228432C12.6649 0.345809 12.9518 0.915238 12.7812 1.44049C12.6105 1.96575 12.0467 2.24653 11.5042 2.14268C10.1843 1.88999 8.81621 1.97294 7.52786 2.39155C5.92112 2.91361 4.52089 3.93094 3.52786 5.29772C2.53484 6.6645 2 8.31056 2 10C2 11.6894 2.53484 13.3355 3.52786 14.7023C4.52089 16.0691 5.92112 17.0864 7.52786 17.6085C9.13461 18.1305 10.8654 18.1305 12.4721 17.6085C14.0789 17.0864 15.4791 16.0691 16.4721 14.7023C17.2684 13.6064 17.77 12.3309 17.9376 10.9974C18.0064 10.4495 18.4477 10 19 10Z"
        />
    )
}

export const UploadIcon = () => {
    return (
        <g id="arrow-up-to-bracket-outline">
            <path
                id="Vector"
                d="M10.2261 3.09762C10.2261 3.09763 10.2261 3.09763 10.2261 3.09763C10.2262 3.0977 10.2263 3.09777 10.2264 3.09784C10.2887 3.16033 10.3238 3.24503 10.3238 3.33333V4.13789L9.99044 3.80456L9.65711 4.13789V3.33333C9.65711 3.24493 9.69223 3.16014 9.75474 3.09763C9.81725 3.03512 9.90204 3 9.99044 3C10.0788 3 10.1636 3.03512 10.2261 3.09762ZM11.3238 5.13789V4.19532L13.5594 6.43104L13.5593 6.4311L13.5656 6.43714C13.5974 6.46789 13.6228 6.50468 13.6403 6.54534C13.6578 6.58601 13.667 6.62975 13.6673 6.67401C13.6677 6.71827 13.6593 6.76216 13.6425 6.80313C13.6258 6.8441 13.601 6.88131 13.5697 6.91261L13.9233 7.26616L13.5697 6.91261C13.5384 6.94391 13.5012 6.96866 13.4602 6.98542C13.4193 7.00218 13.3754 7.01061 13.3311 7.01023C13.2869 7.00984 13.2431 7.00065 13.2025 6.98318C13.1618 6.96571 13.125 6.94032 13.0943 6.90848L13.0943 6.90843L13.0882 6.90228L11.3238 5.13789ZM9.65711 12.5L9.65711 5.55211L9.99044 5.21877L10.3238 5.55211L10.3238 12.5C10.3238 12.5884 10.2887 12.6732 10.2261 12.7357C10.1636 12.7982 10.0788 12.8333 9.99044 12.8333C9.90204 12.8333 9.81725 12.7982 9.75474 12.7357C9.69223 12.6732 9.65711 12.5884 9.65711 12.5ZM8.65711 4.19532V5.13789L6.89649 6.89851C6.83389 6.95777 6.75073 6.9905 6.66445 6.98975C6.57705 6.98899 6.49345 6.95393 6.43165 6.89213C6.36984 6.83033 6.33479 6.74672 6.33403 6.65932C6.33328 6.57304 6.36601 6.48988 6.42526 6.42729L8.65711 4.19532ZM15.5983 12.2643L15.2447 11.9107L15.5983 12.2643C15.6608 12.2018 15.7456 12.1667 15.834 12.1667C15.9224 12.1667 16.0072 12.2018 16.0697 12.2643C16.1322 12.3268 16.1673 12.4116 16.1673 12.5V15C16.1673 15.5304 15.9566 16.0391 15.5815 16.4142C15.2065 16.7893 14.6978 17 14.1673 17H5.83398C5.30355 17 4.79484 16.7893 4.41977 16.4142C4.0447 16.0391 3.83398 15.5304 3.83398 15V12.5C3.83398 12.4116 3.8691 12.3268 3.93161 12.2643C3.99413 12.2018 4.07891 12.1667 4.16732 12.1667C4.25572 12.1667 4.34051 12.2018 4.40302 12.2643C4.46553 12.3268 4.50065 12.4116 4.50065 12.5V15C4.50065 15.3536 4.64113 15.6928 4.89118 15.9428L5.24473 15.5893L4.89118 15.9428C5.14122 16.1929 5.48036 16.3333 5.83398 16.3333H14.1673C14.5209 16.3333 14.8601 16.1929 15.1101 15.9428C15.3602 15.6928 15.5007 15.3536 15.5007 15V12.5C15.5007 12.4116 15.5358 12.3268 15.5983 12.2643Z"
            />
        </g>
    )
}

export const MagnifyingGlassIcon = () => {
    return (
        <g id="search-outline">
            <g id="Vector">
                <path d="M8.50007 14.5C7.31337 14.5 6.15332 14.1481 5.16661 13.4888C4.17991 12.8295 3.41086 11.8925 2.95673 10.7961C2.5026 9.69974 2.38378 8.49334 2.61529 7.32946C2.84681 6.16557 3.41826 5.09648 4.25738 4.25736C5.09651 3.41825 6.16562 2.8468 7.32952 2.61529C8.49342 2.38378 9.69983 2.5026 10.7962 2.95673C11.8926 3.41085 12.8297 4.17989 13.4889 5.16658C14.1482 6.15327 14.5001 7.31331 14.5001 8.5C14.4984 10.0907 13.8656 11.6158 12.7408 12.7407C11.6159 13.8655 10.0908 14.4982 8.50007 14.5ZM8.50007 4C7.61005 4 6.74001 4.26392 5.99998 4.75839C5.25995 5.25285 4.68316 5.95566 4.34257 6.77793C4.00197 7.60019 3.91285 8.50499 4.08649 9.37791C4.26012 10.2508 4.68871 11.0526 5.31806 11.682C5.9474 12.3113 6.74923 12.7399 7.62216 12.9135C8.49508 13.0872 9.39989 12.998 10.2222 12.6575C11.0444 12.3169 11.7473 11.7401 12.2417 11.0001C12.7362 10.26 13.0001 9.39001 13.0001 8.5C12.9989 7.30689 12.5244 6.16299 11.6808 5.31934C10.8371 4.47568 9.69319 4.00119 8.50007 4Z" />
                <path d="M16.7502 17.5C16.5513 17.5 16.3605 17.4209 16.2199 17.2803L13.2199 14.2803C13.0832 14.1388 13.0076 13.9493 13.0094 13.7527C13.0111 13.5561 13.0899 13.3679 13.229 13.2289C13.3681 13.0898 13.5562 13.011 13.7528 13.0092C13.9495 13.0075 14.1389 13.0831 14.2804 13.2198L17.2804 16.2198C17.3853 16.3246 17.4567 16.4583 17.4856 16.6037C17.5145 16.7492 17.4997 16.9 17.4429 17.037C17.3862 17.174 17.2901 17.2911 17.1667 17.3736C17.0434 17.456 16.8985 17.5 16.7502 17.5Z" />
            </g>
        </g>
    )
}

export const SendIcon = () => {
    return (
        <g id="send">
            <path
                id="Vector"
                d="M8.33315 11.6667L17.4998 2.5M8.33315 11.6667L11.2498 17.5C11.2864 17.5798 11.3451 17.6474 11.4189 17.6948C11.4928 17.7422 11.5787 17.7674 11.6665 17.7674C11.7542 17.7674 11.8402 17.7422 11.914 17.6948C11.9879 17.6474 12.0466 17.5798 12.0831 17.5L17.4998 2.5M8.33315 11.6667L2.49981 8.75C2.42003 8.71344 2.35242 8.65474 2.30502 8.58088C2.25762 8.50701 2.23242 8.4211 2.23242 8.33333C2.23242 8.24557 2.25762 8.15965 2.30502 8.08579C2.35242 8.01193 2.42003 7.95323 2.49981 7.91667L17.4998 2.5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    )
}

export const InfoIcon = () => {
    return (
        <g id="info-outline">
            <path
                id="Vector"
                d="M10.0006 3.5H10C8.71442 3.5 7.45772 3.88122 6.3888 4.59545C5.31988 5.30968 4.48676 6.32484 3.99479 7.51256C3.50282 8.70028 3.3741 10.0072 3.6249 11.2681C3.8757 12.529 4.49477 13.6872 5.40381 14.5962C6.31285 15.5052 7.47104 16.1243 8.73192 16.3751C9.99279 16.6259 11.2997 16.4972 12.4874 16.0052C13.6752 15.5132 14.6903 14.6801 15.4046 13.6112C16.1188 12.5423 16.5 11.2856 16.5 10L16.5 9.99944C16.4981 8.27628 15.8127 6.62424 14.5942 5.40578C13.3758 4.18732 11.7237 3.50194 10.0006 3.5ZM9.75 10V9.5H9.25H8.5C8.4337 9.5 8.37011 9.47366 8.32323 9.42678C8.27634 9.37989 8.25 9.31631 8.25 9.25C8.25 9.1837 8.27634 9.12011 8.32323 9.07323C8.37011 9.02634 8.4337 9 8.5 9H10C10.0663 9 10.1299 9.02634 10.1768 9.07323C10.2237 9.12011 10.25 9.1837 10.25 9.25V11.75H9.75V10ZM9.75 12.75H10.25V13C10.25 13.0663 10.2237 13.1299 10.1768 13.1768C10.1299 13.2237 10.0663 13.25 10 13.25C9.9337 13.25 9.87011 13.2237 9.82323 13.1768C9.77634 13.1299 9.75 13.0663 9.75 13V12.75ZM11.2248 13.25C11.2414 13.1683 11.25 13.0846 11.25 13V12.75H11.5C11.5663 12.75 11.6299 12.7763 11.6768 12.8232C11.7237 12.8701 11.75 12.9337 11.75 13C11.75 13.0663 11.7237 13.1299 11.6768 13.1768C11.6299 13.2237 11.5663 13.25 11.5 13.25H11.2248ZM8.75 13C8.75 13.0846 8.75858 13.1683 8.77525 13.25H8.5C8.4337 13.25 8.37011 13.2237 8.32323 13.1768C8.27634 13.1299 8.25 13.0663 8.25 13C8.25 12.9337 8.27634 12.8701 8.32323 12.8232C8.37011 12.7763 8.4337 12.75 8.5 12.75H8.75V13ZM10 17C8.61553 17 7.26216 16.5895 6.11101 15.8203C4.95987 15.0511 4.06266 13.9579 3.53285 12.6788C3.00303 11.3997 2.86441 9.99224 3.13451 8.63437C3.4046 7.2765 4.07129 6.02922 5.05026 5.05026C6.02922 4.07129 7.2765 3.4046 8.63437 3.13451C9.99224 2.86441 11.3997 3.00303 12.6788 3.53285C13.9579 4.06266 15.0511 4.95987 15.8203 6.11101C16.5895 7.26216 17 8.61553 17 10C16.9978 11.8558 16.2596 13.6351 14.9473 14.9473C13.6351 16.2596 11.8558 16.9978 10 17ZM10.25 6.625C10.25 6.97018 9.97018 7.25 9.625 7.25C9.27982 7.25 9 6.97018 9 6.625C9 6.27982 9.27982 6 9.625 6C9.97018 6 10.25 6.27982 10.25 6.625Z"
            />
        </g>
    )
}

export const EyeIcon = () => {
    return (
        <g id="Vector">
            <path d="M2.33268 10.9896L3.51852 9.80297C3.00548 9.29981 2.60525 8.69336 2.34435 8.0238C2.64602 7.21547 5.45352 3.8338 8.99935 3.8338C9.15352 3.8338 9.30018 3.8588 9.45018 3.8713L10.896 2.42547C10.2775 2.25845 9.64003 2.17163 8.99935 2.16714C4.50935 2.16714 0.666016 6.6138 0.666016 8.00047C0.883353 9.151 1.4682 10.1999 2.33268 10.9896Z" />
            <path d="M1.86978 15.36C2.00678 15.4515 2.16787 15.5004 2.33266 15.5005C2.55365 15.5004 2.76558 15.4126 2.92182 15.2563L7.3063 10.8718C7.81826 11.1737 8.40274 11.3338 8.99935 11.3338C9.88341 11.3338 10.7313 10.9826 11.3564 10.3575C11.9815 9.73237 12.3327 8.88453 12.3327 8.00047C12.3327 7.40387 12.1726 6.81938 11.8707 6.30742L16.2552 1.92297C16.3348 1.8461 16.3982 1.75415 16.4419 1.65248C16.4856 1.55081 16.5086 1.44146 16.5095 1.33081C16.5105 1.22016 16.4894 1.11043 16.4475 1.00801C16.4056 0.905599 16.3437 0.812556 16.2655 0.734312C16.1872 0.656068 16.0942 0.594191 15.9918 0.55229C15.8894 0.510389 15.7796 0.489304 15.669 0.490266C15.5583 0.491227 15.449 0.514216 15.3473 0.55789C15.2457 0.601564 15.1537 0.665049 15.0768 0.744641L10.6924 5.12909C10.5588 5.05033 10.4194 4.98069 10.275 4.92087C9.66588 4.66858 8.99565 4.60257 8.34905 4.73119C7.70245 4.8598 7.1085 5.17727 6.64233 5.64345C6.17615 6.10962 5.85868 6.70357 5.73007 7.35017C5.60145 7.99677 5.66746 8.667 5.91975 9.27608C5.97957 9.42049 6.04921 9.55991 6.12797 9.69349L1.74349 14.078C1.62698 14.1945 1.54764 14.343 1.5155 14.5046C1.48336 14.6662 1.49987 14.8338 1.56293 14.986C1.62598 15.1383 1.73277 15.2684 1.86978 15.36ZM8.56783 9.61031C8.60293 9.61971 8.6384 9.62799 8.6742 9.63511C8.9975 9.69942 9.33261 9.66642 9.63716 9.54027C9.9417 9.41412 10.202 9.2005 10.3851 8.92642C10.5683 8.65234 10.666 8.33011 10.666 8.00047C10.666 7.85348 10.6466 7.7085 10.6092 7.56894L8.56783 9.61031ZM9.43084 6.39062L7.38951 8.43196C7.3801 8.39687 7.37183 8.36141 7.36471 8.32562C7.3004 8.00232 7.33341 7.66721 7.45955 7.36267C7.5857 7.05812 7.79932 6.79782 8.0734 6.61469C8.34748 6.43155 8.66972 6.3338 8.99935 6.3338C9.14632 6.3338 9.2913 6.35322 9.43084 6.39062Z" />
            <path d="M15.5168 5.1613L14.3327 6.34214C14.8642 6.82527 15.31 7.395 15.651 8.02714C15.0576 9.28361 14.1145 10.3424 12.9348 11.0766C11.7551 11.8109 10.3887 12.1895 8.99935 12.1671C8.83852 12.1671 8.68435 12.1571 8.53018 12.1488L7.05352 13.6246C7.693 13.7624 8.3452 13.8325 8.99935 13.8338C14.3768 13.8338 17.3327 9.45214 17.3327 8.00047C17.3327 7.0288 15.9685 5.60547 15.5168 5.1613Z" />
        </g>
    )
}

export const CircleIcon = () => {
    return (
        <g id="Icon">
            <path
                id="Icon_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 22C18.866 22 22 18.866 22 15C22 11.134 18.866 8 15 8C11.134 8 8 11.134 8 15C8 18.866 11.134 22 15 22ZM15 11C12.7909 11 11 12.7909 11 15C11 17.2091 12.7909 19 15 19C17.2091 19 19 17.2091 19 15C19 12.7909 17.2091 11 15 11Z"
            />
        </g>
    )
}

export const ChevronIcon = () => {
    return (
        <g id="chevron-down">
            <path
                id="Vector"
                d="M17.25 6.75L9.75 14.25L2.25 6.75"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    )
}

export const CheckMarkIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="6"
            viewBox="0 0 8 6"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.2003L4.26078 4.8L3.01437 6L1.76797 4.8L1.77489 4.79334L0 3.0661L1.24674 1.8661L3.02129 3.59365L6.75359 0L8 1.2003Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

interface RemoveIconProps {
    size?: number
    color?: string
    className?: string
}

export const RemoveIcon: React.FC<RemoveIconProps> = ({
    size = 24,
    color = '#C3CAD9',
    className,
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="Icon">
                <path
                    id="Icon_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7144 6.64043C16.5649 6.49062 16.362 6.40644 16.1504 6.40644C15.9388 6.40644 15.7359 6.49062 15.5864 6.64043L11.6744 10.5444L7.76239 6.63243C7.61293 6.48262 7.41 6.39844 7.19839 6.39844C6.98678 6.39844 6.78386 6.48262 6.63439 6.63243C6.32239 6.94443 6.32239 7.44843 6.63439 7.76043L10.5464 11.6724L6.63439 15.5844C6.32239 15.8964 6.32239 16.4004 6.63439 16.7124C6.94639 17.0244 7.45039 17.0244 7.76239 16.7124L11.6744 12.8004L15.5864 16.7124C15.8984 17.0244 16.4024 17.0244 16.7144 16.7124C17.0264 16.4004 17.0264 15.8964 16.7144 15.5844L12.8024 11.6724L16.7144 7.76043C17.0184 7.45643 17.0184 6.94443 16.7144 6.64043Z"
                    fill={color}
                />
            </g>
        </svg>
    )
}

export const CheckCircleOutline = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Action/check_circle_outline">
                <path
                    id="Icon"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5ZM15 23C10.59 23 7 19.41 7 15C7 10.59 10.59 7 15 7C19.41 7 23 10.59 23 15C23 19.41 19.41 23 15 23ZM18.88 11.29L13 17.17L11.12 15.29C10.9332 15.1027 10.6795 14.9975 10.415 14.9975C10.1505 14.9975 9.89683 15.1027 9.71 15.29C9.32 15.68 9.32 16.31 9.71 16.7L12.3 19.29C12.69 19.68 13.32 19.68 13.71 19.29L20.3 12.7C20.69 12.31 20.69 11.68 20.3 11.29C19.91 10.9 19.27 10.9 18.88 11.29Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export const AlertErrorOutline = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 10C15.55 10 16 10.45 16 11V15C16 15.55 15.55 16 15 16C14.45 16 14 15.55 14 15V11C14 10.45 14.45 10 15 10ZM14.99 5C9.47 5 5 9.48 5 15C5 20.52 9.47 25 14.99 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 14.99 5ZM15 23C10.58 23 7 19.42 7 15C7 10.58 10.58 7 15 7C19.42 7 23 10.58 23 15C23 19.42 19.42 23 15 23ZM16 20H14V18H16V20Z"
                fill="currentColor"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1726_26206"
                    x1="5"
                    y1="15"
                    x2="25"
                    y2="15"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00A3E0" />
                    <stop offset="1" stopColor="#7367FF" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const IconGradient = ({
    d,
    fill,
    viewBox,
}: {
    d: string
    fill?: string
    viewBox?: string
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox={viewBox ? viewBox : '0 0 30 30'}
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d={d}
                fill={fill ? fill : 'url(#paint0_linear_1726_26206)'}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1726_26206"
                    x1="5"
                    y1="15"
                    x2="25"
                    y2="15"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00A3E0" />
                    <stop offset="1" stopColor="#7367FF" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const CloudUploadIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.25 21.7346C36.1167 15.9846 31.0667 11.668 25 11.668C20.1833 11.668 16 14.4013 13.9167 18.4013C8.9 18.9346 5 23.1846 5 28.3346C5 33.8513 9.48333 38.3346 15 38.3346H36.6667C41.2667 38.3346 45 34.6013 45 30.0013C45 25.6013 41.5833 22.0346 37.25 21.7346ZM28.3333 26.668V33.3346H21.6667V26.668H16.6667L24.4167 18.918C24.75 18.5846 25.2667 18.5846 25.6 18.918L33.3333 26.668H28.3333Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const FileIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C7.9 5 7.01 5.9 7.01 7L7 23C7 24.1 7.89 25 8.99 25H21C22.1 25 23 24.1 23 23V11.83C23 11.3 22.79 10.79 22.41 10.42L17.58 5.59C17.21 5.21 16.7 5 16.17 5H9ZM16 11V6.5L21.5 12H17C16.45 12 16 11.55 16 11Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}
export const TrashIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 22C9 23.1 9.9 24 11 24H19C20.1 24 21 23.1 21 22V12C21 10.9 20.1 10 19 10H11C9.9 10 9 10.9 9 12V22ZM21 7H18.5L17.79 6.29C17.61 6.11 17.35 6 17.09 6H12.91C12.65 6 12.39 6.11 12.21 6.29L11.5 7H9C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9H21C21.55 9 22 8.55 22 8C22 7.45 21.55 7 21 7Z"
                fill="url(#paint0_linear_1652_77278)"
                fillOpacity="0.85"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1652_77278"
                    x1="21.7059"
                    y1="15"
                    x2="8.53313"
                    y2="17.65"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F11E83" />
                    <stop offset="1" stopColor="#FF4747" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const ActionCheckCircle = () => {
    return (
        <g id="Icon">
            <path
                id="Icon_2"
                stroke="white"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.9993 5.16797C8.84735 5.16797 4.66602 9.3493 4.66602 14.5013C4.66602 19.6533 8.84735 23.8346 13.9993 23.8346C19.1514 23.8346 23.3327 19.6533 23.3327 14.5013C23.3327 9.3493 19.1514 5.16797 13.9993 5.16797ZM11.47 18.5053L8.11935 15.1546C7.94458 14.9803 7.84636 14.7435 7.84636 14.4966C7.84636 14.2498 7.94458 14.013 8.11935 13.8386C8.48335 13.4746 9.07135 13.4746 9.43535 13.8386L12.1327 16.5266L18.554 10.1053C18.918 9.7413 19.506 9.7413 19.87 10.1053C20.234 10.4693 20.234 11.0573 19.87 11.4213L12.786 18.5053C12.4313 18.8693 11.834 18.8693 11.47 18.5053Z"
                fill="#C3CAD9"
            />
        </g>
    )
}

export const DateIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 6H22V5C22 4.45 21.55 4 21 4C20.45 4 20 4.45 20 5V6H10V5C10 4.45 9.55 4 9 4C8.45 4 8 4.45 8 5V6H7C5.9 6 5 6.9 5 8V24C5 25.1 5.9 26 7 26H23C24.1 26 25 25.1 25 24V8C25 6.9 24.1 6 23 6ZM22 24H8C7.45 24 7 23.55 7 23V11H23V23C23 23.55 22.55 24 22 24Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ArrowLeftIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2925 9.29249C18.1057 9.10523 17.852 9 17.5875 9C17.323 9 17.0693 9.10523 16.8825 9.29249L12.2925 13.8825C11.9025 14.2725 11.9025 14.9025 12.2925 15.2925L16.8825 19.8825C17.2725 20.2725 17.9025 20.2725 18.2925 19.8825C18.6825 19.4925 18.6825 18.8625 18.2925 18.4725L14.4125 14.5825L18.2925 10.7025C18.6825 10.3125 18.6725 9.67249 18.2925 9.29249Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ArrowRightIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2925 9.29376C11.9025 9.68376 11.9025 10.3138 12.2925 10.7038L16.1725 14.5838L12.2925 18.4638C11.9025 18.8538 11.9025 19.4838 12.2925 19.8738C12.6825 20.2638 13.3125 20.2638 13.7025 19.8738L18.2925 15.2838C18.6825 14.8938 18.6825 14.2638 18.2925 13.8738L13.7025 9.28376C13.3225 8.90376 12.6825 8.90376 12.2925 9.29376Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ArrowDownIcon = () => {
    return (
        <svg
            width="30"
            height="31"
            viewBox="0 0 20 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.35641 10.8805C5.86641 11.3705 5.86641 12.1605 6.35641 12.6505L14.6664 20.9605C15.0564 21.3505 15.6864 21.3505 16.0764 20.9605L24.3864 12.6505C24.8764 12.1605 24.8764 11.3705 24.3864 10.8805C23.8964 10.3905 23.1064 10.3905 22.6164 10.8805L15.3664 18.1205L8.11641 10.8705C7.63641 10.3905 6.83641 10.3905 6.35641 10.8805Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}
export const ArrowUpIcon = () => {
    return (
        <svg
            width="30"
            height="31"
            viewBox="0 0 20 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6436 19.6195C24.1336 19.1295 24.1336 18.3395 23.6436 17.8495L15.3336 9.53952C14.9436 9.14952 14.3136 9.14952 13.9236 9.53952L5.61359 17.8495C5.12359 18.3395 5.12359 19.1295 5.61359 19.6195C6.10359 20.1095 6.89359 20.1095 7.38359 19.6195L14.6336 12.3795L21.8836 19.6295C22.3636 20.1095 23.1636 20.1095 23.6436 19.6195Z"
                fill="#2CAAE2"
            />
        </svg>
    )
}

export const TimeIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.99 5C9.47 5 5 9.48 5 15C5 20.52 9.47 25 14.99 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 14.99 5ZM15 23C10.58 23 7 19.42 7 15C7 10.58 10.58 7 15 7C19.42 7 23 10.58 23 15C23 19.42 19.42 23 15 23ZM14.78 10H14.72C14.32 10 14 10.32 14 10.72V15.44C14 15.79 14.18 16.12 14.49 16.3L18.64 18.79C18.98 18.99 19.42 18.89 19.62 18.55C19.83 18.21 19.72 17.76 19.37 17.56L15.5 15.26V10.72C15.5 10.32 15.18 10 14.78 10Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const ChevronResize = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9888 15.9988H13.5099C13.2454 15.9985 12.9916 16.1035 12.8046 16.2905C12.6175 16.4776 12.5126 16.7313 12.5129 16.9958C12.5129 17.5474 12.9583 17.9929 13.5099 17.9929L18 17.9999C18.5516 17.9999 18.997 17.5545 18.997 17.0029L18.997 12.5199C18.997 11.9683 18.5516 11.5228 18 11.5228C17.7355 11.5225 17.4817 11.6275 17.2947 11.8145C17.1076 12.0016 17.0027 12.2553 17.003 12.5199L16.9888 15.9988Z"
                fill="#C3CAD9"
            />
        </svg>
    )
}

export const VisibleOnIcon = () => {
    return (
        <path
            stroke="none"
            d="M15 8C10 8 5.73 11.11 4 15.5C5.73 19.89 10 23 15 23C20 23 24.27 19.89 26 15.5C24.27 11.11 20 8 15 8ZM15 20.5C12.24 20.5 10 18.26 10 15.5C10 12.74 12.24 10.5 15 10.5C17.76 10.5 20 12.74 20 15.5C20 18.26 17.76 20.5 15 20.5ZM15 12.5C13.34 12.5 12 13.84 12 15.5C12 17.16 13.34 18.5 15 18.5C16.66 18.5 18 17.16 18 15.5C18 13.84 16.66 12.5 15 12.5Z"
            fill="#C3CAD9"
        />
    )
}

export const VisibleOffIcon = () => {
    return (
        <path
            stroke="none"
            fill="#C3CAD9"
            d="M15 9.6325C17.76 9.6325 20 11.8725 20 14.6325C20 15.1425 19.9 15.6325 19.76 16.0925L22.82 19.1525C24.21 17.9225 25.31 16.3825 26 14.6225C24.27 10.2425 20 7.1325 15 7.1325C13.73 7.1325 12.51 7.3325 11.36 7.7025L13.53 9.8725C14 9.7325 14.49 9.6325 15 9.6325ZM5.71 6.2925C5.32 6.6825 5.32 7.3125 5.71 7.7025L7.68 9.6725C6.06 10.9625 4.77 12.6625 4 14.6325C5.73 19.0225 10 22.1325 15 22.1325C16.52 22.1325 17.97 21.8325 19.31 21.3125L22.03 24.0325C22.42 24.4225 23.05 24.4225 23.44 24.0325C23.83 23.6425 23.83 23.0125 23.44 22.6225L7.13 6.2925C6.74 5.9025 6.1 5.9025 5.71 6.2925ZM15 19.6325C12.24 19.6325 10 17.3925 10 14.6325C10 13.8625 10.18 13.1325 10.49 12.4925L12.06 14.0625C12.03 14.2425 12 14.4325 12 14.6325C12 16.2925 13.34 17.6325 15 17.6325C15.2 17.6325 15.38 17.6025 15.57 17.5625L17.14 19.1325C16.49 19.4525 15.77 19.6325 15 19.6325ZM17.97 14.3025C17.82 12.9025 16.72 11.8125 15.33 11.6625L17.97 14.3025Z"
        />
    )
}

export const DropdownIcon = ` <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M7.14166 8.195L9.72832 10.7817L12.315 8.195C12.575 7.935 12.995 7.935 13.255 8.195C13.515 8.455 13.515 8.875 13.255 9.135L10.195 12.195C9.93499 12.455 9.51499 12.455 9.25499 12.195L6.19499 9.135C6.07016 9.01045 6 8.84135 6 8.665C6 8.48865 6.07016 8.31955 6.19499 8.195C6.45499 7.94167 6.88166 7.935 7.14166 8.195Z"
            fill="#C3CAD9"
        />
    </svg>`

export const PlaceIcon = `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                >
                    <path
                        d="M15 5C11.13 5 8 8.13 8 12C8 16.17 12.42 21.92 14.24 24.11C14.64 24.59 15.37 24.59 15.77 24.11C17.58 21.92 22 16.17 22 12C22 8.13 18.87 5 15 5ZM15 14.5C13.62 14.5 12.5 13.38 12.5 12C12.5 10.62 13.62 9.5 15 9.5C16.38 9.5 17.5 10.62 17.5 12C17.5 13.38 16.38 14.5 15 14.5Z"
                        fill="#C3CAD9"
                    />
                </svg>`
export const ChevronDropdownIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4987 11.4722L14.12 15.0936L17.7414 11.4722C18.1054 11.1082 18.6934 11.1082 19.0574 11.4722C19.4214 11.8362 19.4214 12.4242 19.0574 12.7882L14.7734 17.0722C14.4094 17.4362 13.8214 17.4362 13.4574 17.0722L9.17338 12.7882C8.99861 12.6138 8.90039 12.3771 8.90039 12.1302C8.90039 11.8833 8.99861 11.6466 9.17338 11.4722C9.53738 11.1176 10.1347 11.1082 10.4987 11.4722Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}

export const ChevronDropdownUpIcon = () => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4987 17.0722L14.1201 13.4509L17.7414 17.0722C18.1054 17.4362 18.6934 17.4362 19.0574 17.0722C19.4214 16.7082 19.4214 16.1202 19.0574 15.7562L14.7734 11.4722C14.599 11.2974 14.3623 11.1992 14.1154 11.1992C13.8685 11.1992 13.6318 11.2974 13.4574 11.4722L9.17339 15.7562C8.80939 16.1202 8.80939 16.7082 9.17339 17.0722C9.53739 17.4269 10.1347 17.4362 10.4987 17.0722Z"
            fill="#9194AF"
            stroke="none"
        />
    )
}

export const ShortTextIcon = () => {
    return (
        <path
            width="28"
            height="28"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.46654 11.2031H20.5332C21.0465 11.2031 21.4665 11.6231 21.4665 12.1365C21.4665 12.6498 21.0465 13.0698 20.5332 13.0698H7.46654C6.9532 13.0698 6.5332 12.6498 6.5332 12.1365C6.5332 11.6231 6.9532 11.2031 7.46654 11.2031ZM7.46654 14.9365H14.9332C15.4465 14.9365 15.8665 15.3565 15.8665 15.8698C15.8665 16.3831 15.4465 16.8031 14.9332 16.8031H7.46654C6.9532 16.8031 6.5332 16.3831 6.5332 15.8698C6.5332 15.3565 6.9532 14.9365 7.46654 14.9365Z"
            fill="#C3CAD9"
            stroke="none"
        />
    )
}
